export default "__VITE_ASSET__De_ck7wt__"